//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services.js";
import TraitsTable from "@/pages/Warehouses/components/traitsTable.vue";
import GeographyTable from "@/pages/Warehouses/components/geographyTable.vue";
import TraitsTab from "@/pages/Warehouses/components/traitsTab.vue";
import GeographyTab from "@/pages/Warehouses/components/geographyTab.vue";
import AssociatedStores from "@/pages/Warehouses/components/associatedStores.vue";

const EMPTY_STORAGE_FACILIY = {
  geography: [{ id: null }, { id: null }, { id: null }],
  least_geo_level_id: null,
};

export default {
  name: "WarehouseManagement",
  components: {
    TraitsTable,
    GeographyTable,
    TraitsTab,
    GeographyTab,
    AssociatedStores,
  },
  mounted: function () {
    BackendServices.getWarehouses().then((response) => {
      this.recordsTotal = response.headers["x-total-count"];
      this.data = response.data;
      this.isLoading = false;
    });
    this.$store.commit("setDatePickerState", false);
  },
  data: () => ({
    data: [],
    traitsForm: false,
    geographyForm: false,
    associatedStoresForm: false,
    tableTab: "traits",
    tab: "traits",
    filterState: null,
    rightSidePane: false,
    separator: "cell",
    storageFacility: {
      least_geo_level_id: null,
    },
    recordsTotal: null,
    isLoading: false,
  }),
  methods: {
    createNewWarehouse: function () {
      this.rightSidePane = true;
      this.traitsForm = false;
      this.geographyForm = false;
      this.associatedStoresForm = false;
      this.storageFacility = EMPTY_STORAGE_FACILIY;
    },
    askForData: function (event) {
      this.isLoading = true;
      BackendServices.getWarehouses(event.pagination, event.filter).then(
        (response) => {
          this.recordsTotal = response.headers["x-total-count"];
          this.data = response.data;
          this.isLoading = false;
        }
      );
    },
    openExistingWarehouse: function (event) {
      this.rightSidePane = true;
      this.traitsForm = true;
      this.geographyForm = true;
      this.associatedStoresForm = true;
      this.storageFacility = event;
    },
    closeForm: function () {
      this.rightSidePane = false;
      this.storageFacility = {};
    },
    saveWarehouse: function () {
      let operation = !this.storageFacility.id
        ? BackendServices.createNewWarehouse(this.storageFacility)
        : BackendServices.updateExistingWarehouse(this.storageFacility);
      operation.then(() => window.location.reload());
    },
    removeWarehouse: function (warehouse) {
      BackendServices.deleteWarehouse(warehouse)
        .then(() => window.location.reload())
        .catch((error) =>
          this.$q.notify({ message: error.response.data.error, color: "red" })
        );
    },
    exportFilteredWarehouses: function () {
      BackendServices.downloadWarehouseList().then((response) => {
        const downloadUrl = window.URL.createObjectURL(
          new Blob([response.data])
        );
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", "Warehouses.xlsx"); //any other extension
        document.body.appendChild(link);
        link.click();
        link.remove();
      });
    },
  },
};
